import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import Skeleton from 'react-loading-skeleton';
import { has, isEqual } from 'lodash';
import { StyleSheet, css } from 'aphrodite/no-important';
import queryString from 'query-string';
import Tile from '../Layout/Tile';
import Actions from '../../../Actions';
import Permissions from "../../../Utilities/Permissions";
import JobRow from './JobRow';
import ListHeader from './ListHeader';
import JobAdd from './Add';
import Edit from './Edit';
import Logs from './Logs';
import AdvancedSearch from './AdvancedSearch';
import Paginate from '../Layout/Paginate';

class JobList extends Component {
    constructor(props){
        super(props);
        this.permissions = new Permissions(props.auth.permissions);
    }

    componentDidMount = () => {
        const { auth, getJobs, query, url: {location: { hash } }, toggleModal } = this.props;
        const urlQuery = queryString.parse(hash);
        this.setState({search: query.text_filter });
        getJobs(auth.token, {page: 1,sort: 'vanity_id', order: 'desc' ,status: [1,2,3,4], ...urlQuery }, false);
        if(has(urlQuery,"add")){
            toggleModal("jobs","add");
        }else if(has(urlQuery,"edit")){
            this.edit(urlQuery.edit);
        }
    
    }

    componentDidUpdate = (prevProps) => {
        const { toggleModal, url: { location: { hash: newHash } } } = this.props;
        const { url: { location: { hash: oldHash } } } = prevProps;
        if(!isEqual(newHash,oldHash)){
            const { auth, getJobs } = this.props;
            const query = queryString.parse(newHash);
            getJobs(auth.token, { page: 1,sort: 'vanity_id', order: 'desc' ,...query }, false);
            if(has(query,"add")){
                toggleModal("jobs","add");
            }else if(has(query,"edit")){
                this.edit(query.edit);
            }
        }
    }

    edit = (id) => {
        const { jobs, toggleModal, setModalData } = this.props;
        if(jobs.hasOwnProperty(id)){
            setModalData("jobs","edit",jobs[id]);
            toggleModal("jobs","edit");
        }
    }

    logs = (id) => {
        const { jobs, toggleModal, setModalData } = this.props;
        if(jobs.hasOwnProperty(id)){
            const {logs = []} = jobs[id];
            setModalData("jobs","logs",{ logs });
            toggleModal("jobs","logs");
        }
    }

    jobsLoading = () => {
        const data = [];
        const { jobCol } = styles;

        for(let i=0;i<10;i++){
            data.push(
                <Tile xs="12" key={i} className={`mx-auto ${css(jobCol)}`}>
                    <Skeleton count={4}/>
                </Tile>
            );
        }

        return data;
    }

    jobs = () => {
        const { jobs, jobsMeta } = this.props;
        const data = [];
        jobsMeta.data.map((id) => {
            data.push(
                <JobRow permissions={this.permissions} key={jobs[id].id} showLogs={this.logs} edit={this.edit} job={jobs[id]}/>
            );
        });
        return data;
    }

    render(){
        const { getJobs, jobsLoading, jobsMeta } = this.props;
        const { tooltip } = styles;
        return (
            <div style={{ padding: "3px"}}>        
                {jobsLoading ? this.jobsLoading():
                <div>
                    <Table responsive hover className="text-center">
                        <thead>
                            <ListHeader permissions={this.permissions}/>
                        </thead>
                        <tbody>
                            {this.jobs()}
                        </tbody>
                    </Table>
                    <Paginate fetch={getJobs} meta={jobsMeta}  />
                    <AdvancedSearch refresh={getJobs} />
                    <JobAdd />
                    <ReactTooltip html={true} effect="solid" place="bottom" className={css(tooltip)}/>
                    <Edit />
                    <Logs />
                </div>
                }
            </div>            
        );
    }
}

const styles = StyleSheet.create({
    jobCol: {
        padding: "1vh 1vw",
    },
    tooltip: {
        maxWidth: "500px",
        "@media (max-width: 760px)": {
            maxWidth: "65%",
        },
    }
});

const mapStateToProps = (state) => ({
    auth: state.auth,
    jobs: state.jobStore.jobs,
    jobsMeta: state.jobStore.jobsMeta,
    query: state.jobStore.query,
    jobsLoading: state.jobStore.jobsLoading,
});
const { jobs, modals } = Actions;
export default connect(mapStateToProps,{...jobs, ...modals })(JobList);


// WEBPACK FOOTER //
// ./src/Components/App/Jobs/JobList.js